import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';
import QUERY_PUBLISHER_USERS from '../../graphql/queries/QueryPublisherUsers';
import { setPubUsers } from '../../redux/pubusers/pubusersSlice';
import { setPubInvites } from '../../redux/pubinvites/pubinvitesSlice';
import { setUserRoles } from '../../redux/userroles/userrolesSlice';

/**
 * A component that fetches and refreshes team data in the Redux store.
 * This component doesn't render anything visible, it just performs data fetching.
 */
function RefreshTeamData() {
  const currentpublisher = useSelector((state) => state.currentpublisher.value);
  const dispatch = useDispatch();

  // Fetch team data
  const { loading, error, data, refetch } = useQuery(QUERY_PUBLISHER_USERS, {
    variables: { publisher: String(currentpublisher.id) },
    fetchPolicy: 'network-only', // Don't use cache, always make a network request
  });

  // Update Redux store when data is fetched
  useEffect(() => {
    if (data) {
      console.log("RefreshTeamData - Fetched data:", data);
      console.log("RefreshTeamData - publisherusers:", data.publisherusers);
      console.log("RefreshTeamData - userroles:", data.userroles);
      console.log("RefreshTeamData - publisherinvitations:", data.publisherinvitations);

      dispatch(setPubUsers(data.publisherusers));
      dispatch(setPubInvites(data.publisherinvitations));
      dispatch(setUserRoles(data.userroles));

      console.log("RefreshTeamData - Dispatched to Redux store");
    } else {
      console.log("RefreshTeamData - No data fetched yet");
    }

    if (error) {
      console.error("RefreshTeamData - Error fetching data:", error);
    }
  }, [data, dispatch, error]);

  // Refetch data every 30 seconds to keep it fresh
  useEffect(() => {
    const intervalId = setInterval(() => {
      refetch();
    }, 30000);

    return () => clearInterval(intervalId);
  }, [refetch]);

  return null; // This component doesn't render anything
}

export default RefreshTeamData;
